import { jsonParse, jsonStringify } from 'utils/json';

export default class StorageService {
  #storageProvider;
  #storageId;
  #logger;

  constructor(storageProvider, logger, storageId) {
    this.#storageProvider = storageProvider;
    this.#storageId = storageId || '';
    this.#logger = logger;
  }

  #getItemKeyName = key => {
    return `${this.#storageId}${key}`;
  };

  setItem = (key, value, shouldStringify) => {
    const keyName = this.#getItemKeyName(key);

    try {
      const keyValue = shouldStringify ? jsonStringify(value) : value;
      this.#storageProvider.setItem(keyName, keyValue);
    } catch (err) {
      this.#logger.error(err);
    }
  };

  getItem = key => {
    const keyName = this.#getItemKeyName(key);

    return this.#storageProvider.getItem(keyName);
  };

  getParsedItem = key => {
    const keyName = this.#getItemKeyName(key);
    const data = this.getItem(keyName);

    try {
      return jsonParse(data);
    } catch (err) {
      this.#logger.error(err);

      return null;
    }
  };

  removeItem = key => {
    const keyName = this.#getItemKeyName(key);

    this.#storageProvider.removeItem(keyName);
  };

  clearStorage = () => {
    const keys = Object.keys(this.#storageProvider);

    keys.forEach(key => {
      const isKeyForCurrentStorage = this.#storageId && key.startsWith(this.#storageId);

      if (isKeyForCurrentStorage) {
        this.#storageProvider.removeItem(key);
      }
    });
  };
}
